/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/infobip_kakao_sender_keys_data" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdInfobipKakaoSenderKeysData } from "./constants";
import type { InfobipKakaoSenderKeysParams, InfobipKakaoSenderKeysResult } from "./types";
import { isInfobipKakaoSenderKeysResult } from "./validators";

export const getDataTableInfobipKakaoSenderKeys = reactQueryTableFetcherAdapter(
  engagementAppGroupIdInfobipKakaoSenderKeysData,
  (
    signal: AbortSignal,
    { appGroupId, limit, start = 0, sortdir, sortby }: InfobipKakaoSenderKeysParams
  ): Promise<InfobipKakaoSenderKeysResult> => {
    return fetch(
      `/engagement/${appGroupId}/infobip_kakao_sender_keys_data`,
      "GET",
      {
        limit,
        sortby,
        sortdir,
        start,
      },
      { signal }
    );
  },
  isInfobipKakaoSenderKeysResult
);
